import React, { useState, useEffect } from 'react';
import { Plus, Search, Eye, Trash2, CheckCircle, Clock, XCircle, X } from 'lucide-react';
import { toast } from 'react-hot-toast';
import { useAuth } from '../../contexts/AuthContext';
import { resourceApi } from '../../services/seller/resourceApi';
import { Line } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler
} from 'chart.js';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler
);

const SellerResources = () => {
  const { token } = useAuth();
  const [resources, setResources] = useState([]);
  const [filteredResources, setFilteredResources] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedResourceType, setSelectedResourceType] = useState('total');
  const [searchTerm, setSearchTerm] = useState('');
  const [statusFilter, setStatusFilter] = useState('all');
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [showAddModal, setShowAddModal] = useState(false);
  const [showDetailModal, setShowDetailModal] = useState(false);
  const [selectedResource, setSelectedResource] = useState(null);
  
  const [newResource, setNewResource] = useState({
    type: 'temu',
    storeName: '',
    email: '',
    password: '',
    ip: '',
    status: 'active'
  });

  // Mock data
  const mockResources = [
    {
      id: 1,
      type: 'temu',
      storeName: 'Temu Store 1',
      email: 'store1@temu.com',
      password: 'password123',
      ip: '192.168.1.100',
      status: 'active',
      createdAt: '2024-01-15',
      lastActivity: '2024-01-20',
      notes: 'Store hoạt động tốt',
      activities: [
        { date: '2024-01-20', content: 'Đăng nhập thành công', note: 'Hoạt động bình thường' },
        { date: '2024-01-19', content: 'Cập nhật thông tin', note: 'Thay đổi mật khẩu' }
      ]
    },
    {
      id: 2,
      type: 'gmc',
      storeName: 'GMC Store 1',
      email: 'store1@gmc.com',
      password: 'password456',
      ip: '192.168.1.101',
      status: 'suspended',
      createdAt: '2024-01-10',
      lastActivity: '2024-01-18',
      notes: 'Store bị tạm ngưng',
      activities: [
        { date: '2024-01-18', content: 'Tài khoản bị tạm ngưng', note: 'Vi phạm chính sách' }
      ]
    },
    {
      id: 3,
      type: 'tiktok',
      storeName: 'TikTok Store 1',
      email: 'store1@tiktok.com',
      password: 'password789',
      ip: '192.168.1.102',
      status: 'pending',
      createdAt: '2024-01-05',
      lastActivity: '2024-01-15',
      notes: 'Đang chờ duyệt',
      activities: [
        { date: '2024-01-15', content: 'Đăng ký thành công', note: 'Chờ admin duyệt' }
      ]
    },
    {
      id: 4,
      type: 'temu',
      storeName: 'Temu Store 2',
      email: 'store2@temu.com',
      password: 'password124',
      ip: '192.168.1.103',
      status: 'active',
      createdAt: '2024-01-12',
      lastActivity: '2024-01-21',
      notes: 'Store mới tạo',
      activities: [
        { date: '2024-01-21', content: 'Tạo store mới', note: 'Thành công' }
      ]
    },
    {
      id: 5,
      type: 'gmc',
      storeName: 'GMC Store 2',
      email: 'store2@gmc.com',
      password: 'password457',
      ip: '192.168.1.104',
      status: 'active',
      createdAt: '2024-01-08',
      lastActivity: '2024-01-19',
      notes: 'Store hoạt động ổn định',
      activities: [
        { date: '2024-01-19', content: 'Cập nhật sản phẩm', note: 'Thêm 50 sản phẩm mới' }
      ]
    },
    {
      id: 6,
      type: 'tiktok',
      storeName: 'TikTok Store 2',
      email: 'store2@tiktok.com',
      password: 'password790',
      ip: '192.168.1.105',
      status: 'suspended',
      createdAt: '2024-01-03',
      lastActivity: '2024-01-14',
      notes: 'Vi phạm nội dung',
      activities: [
        { date: '2024-01-14', content: 'Tài khoản bị khóa', note: 'Nội dung không phù hợp' }
      ]
    },
    {
      id: 7,
      type: 'temu',
      storeName: 'Temu Store 3',
      email: 'store3@temu.com',
      password: 'password125',
      ip: '192.168.1.106',
      status: 'pending',
      createdAt: '2024-01-20',
      lastActivity: '2024-01-22',
      notes: 'Chờ xác minh',
      activities: [
        { date: '2024-01-22', content: 'Gửi yêu cầu xác minh', note: 'Đang chờ phản hồi' }
      ]
    },
    {
      id: 8,
      type: 'gmc',
      storeName: 'GMC Store 3',
      email: 'store3@gmc.com',
      password: 'password458',
      ip: '192.168.1.107',
      status: 'active',
      createdAt: '2024-01-06',
      lastActivity: '2024-01-20',
      notes: 'Store bán hàng tốt',
      activities: [
        { date: '2024-01-20', content: 'Đơn hàng mới', note: 'Doanh thu tăng 20%' }
      ]
    },
    {
      id: 9,
      type: 'tiktok',
      storeName: 'TikTok Store 3',
      email: 'store3@tiktok.com',
      password: 'password791',
      ip: '192.168.1.108',
      status: 'active',
      createdAt: '2024-01-01',
      lastActivity: '2024-01-21',
      notes: 'Store viral',
      activities: [
        { date: '2024-01-21', content: 'Video viral', note: '1M lượt xem' }
      ]
    },
    {
      id: 10,
      type: 'temu',
      storeName: 'Temu Store 4',
      email: 'store4@temu.com',
      password: 'password126',
      ip: '192.168.1.109',
      status: 'suspended',
      createdAt: '2024-01-14',
      lastActivity: '2024-01-17',
      notes: 'Gian lận',
      activities: [
        { date: '2024-01-17', content: 'Phát hiện gian lận', note: 'Tạm khóa điều tra' }
      ]
    },
    {
      id: 11,
      type: 'gmc',
      storeName: 'GMC Store 4',
      email: 'store4@gmc.com',
      password: 'password459',
      ip: '192.168.1.110',
      status: 'pending',
      createdAt: '2024-01-11',
      lastActivity: '2024-01-18',
      notes: 'Chờ duyệt sản phẩm',
      activities: [
        { date: '2024-01-18', content: 'Gửi sản phẩm duyệt', note: '50 sản phẩm chờ duyệt' }
      ]
    },
    {
      id: 12,
      type: 'tiktok',
      storeName: 'TikTok Store 4',
      email: 'store4@tiktok.com',
      password: 'password792',
      ip: '192.168.1.111',
      status: 'active',
      createdAt: '2024-01-07',
      lastActivity: '2024-01-22',
      notes: 'Store thời trang',
      activities: [
        { date: '2024-01-22', content: 'Live stream thành công', note: '5000 người xem' }
      ]
    },
    {
      id: 13,
      type: 'temu',
      storeName: 'Temu Store 5',
      email: 'store5@temu.com',
      password: 'password127',
      ip: '192.168.1.112',
      status: 'active',
      createdAt: '2024-01-09',
      lastActivity: '2024-01-21',
      notes: 'Store điện tử',
      activities: [
        { date: '2024-01-21', content: 'Đơn hàng lớn', note: '1000 sản phẩm' }
      ]
    },
    {
      id: 14,
      type: 'gmc',
      storeName: 'GMC Store 5',
      email: 'store5@gmc.com',
      password: 'password460',
      ip: '192.168.1.113',
      status: 'suspended',
      createdAt: '2024-01-04',
      lastActivity: '2024-01-16',
      notes: 'Vi phạm bản quyền',
      activities: [
        { date: '2024-01-16', content: 'Báo cáo vi phạm', note: 'Sản phẩm giả mạo' }
      ]
    },
    {
      id: 15,
      type: 'tiktok',
      storeName: 'TikTok Store 5',
      email: 'store5@tiktok.com',
      password: 'password793',
      ip: '192.168.1.114',
      status: 'pending',
      createdAt: '2024-01-13',
      lastActivity: '2024-01-19',
      notes: 'Chờ xác minh danh tính',
      activities: [
        { date: '2024-01-19', content: 'Gửi giấy tờ', note: 'Chờ admin xác minh' }
      ]
    },
    {
      id: 16,
      type: 'temu',
      storeName: 'Temu Store 6',
      email: 'store6@temu.com',
      password: 'password128',
      ip: '192.168.1.115',
      status: 'active',
      createdAt: '2024-01-02',
      lastActivity: '2024-01-22',
      notes: 'Store gia dụng',
      activities: [
        { date: '2024-01-22', content: 'Khuyến mãi thành công', note: 'Tăng 300% doanh thu' }
      ]
    },
    {
      id: 17,
      type: 'gmc',
      storeName: 'GMC Store 6',
      email: 'store6@gmc.com',
      password: 'password461',
      ip: '192.168.1.116',
      status: 'active',
      createdAt: '2024-01-16',
      lastActivity: '2024-01-21',
      notes: 'Store mỹ phẩm',
      activities: [
        { date: '2024-01-21', content: 'Sản phẩm hot', note: 'Bán chạy nhất' }
      ]
    },
    {
      id: 18,
      type: 'tiktok',
      storeName: 'TikTok Store 6',
      email: 'store6@tiktok.com',
      password: 'password794',
      ip: '192.168.1.117',
      status: 'suspended',
      createdAt: '2024-01-08',
      lastActivity: '2024-01-15',
      notes: 'Nội dung không phù hợp',
      activities: [
        { date: '2024-01-15', content: 'Báo cáo nội dung', note: 'Vi phạm cộng đồng' }
      ]
    },
    {
      id: 19,
      type: 'temu',
      storeName: 'Temu Store 7',
      email: 'store7@temu.com',
      password: 'password129',
      ip: '192.168.1.118',
      status: 'pending',
      createdAt: '2024-01-17',
      lastActivity: '2024-01-20',
      notes: 'Chờ duyệt store',
      activities: [
        { date: '2024-01-20', content: 'Gửi hồ sơ', note: 'Chờ admin duyệt' }
      ]
    },
    {
      id: 20,
      type: 'gmc',
      storeName: 'GMC Store 7',
      email: 'store7@gmc.com',
      password: 'password462',
      ip: '192.168.1.119',
      status: 'active',
      createdAt: '2024-01-05',
      lastActivity: '2024-01-22',
      notes: 'Store thực phẩm',
      activities: [
        { date: '2024-01-22', content: 'Đơn hàng mới', note: '50kg thực phẩm' }
      ]
    },
    {
      id: 21,
      type: 'tiktok',
      storeName: 'TikTok Store 7',
      email: 'store7@tiktok.com',
      password: 'password795',
      ip: '192.168.1.120',
      status: 'active',
      createdAt: '2024-01-10',
      lastActivity: '2024-01-21',
      notes: 'Store làm đẹp',
      activities: [
        { date: '2024-01-21', content: 'Tutorial thành công', note: '100K lượt xem' }
      ]
    },
    {
      id: 22,
      type: 'temu',
      storeName: 'Temu Store 8',
      email: 'store8@temu.com',
      password: 'password130',
      ip: '192.168.1.121',
      status: 'suspended',
      createdAt: '2024-01-12',
      lastActivity: '2024-01-18',
      notes: 'Gian lận thanh toán',
      activities: [
        { date: '2024-01-18', content: 'Phát hiện gian lận', note: 'Tạm khóa điều tra' }
      ]
    },
    {
      id: 23,
      type: 'gmc',
      storeName: 'GMC Store 8',
      email: 'store8@gmc.com',
      password: 'password463',
      ip: '192.168.1.122',
      status: 'pending',
      createdAt: '2024-01-15',
      lastActivity: '2024-01-19',
      notes: 'Chờ xác minh sản phẩm',
      activities: [
        { date: '2024-01-19', content: 'Gửi mẫu sản phẩm', note: 'Chờ kiểm định' }
      ]
    },
    {
      id: 24,
      type: 'tiktok',
      storeName: 'TikTok Store 8',
      email: 'store8@tiktok.com',
      password: 'password796',
      ip: '192.168.1.123',
      status: 'active',
      createdAt: '2024-01-06',
      lastActivity: '2024-01-22',
      notes: 'Store công nghệ',
      activities: [
        { date: '2024-01-22', content: 'Review sản phẩm', note: '500K lượt xem' }
      ]
    },
    {
      id: 25,
      type: 'temu',
      storeName: 'Temu Store 9',
      email: 'store9@temu.com',
      password: 'password131',
      ip: '192.168.1.124',
      status: 'active',
      createdAt: '2024-01-11',
      lastActivity: '2024-01-21',
      notes: 'Store thời trang nam',
      activities: [
        { date: '2024-01-21', content: 'Bộ sưu tập mới', note: '100 sản phẩm mới' }
      ]
    },
    {
      id: 26,
      type: 'gmc',
      storeName: 'GMC Store 9',
      email: 'store9@gmc.com',
      password: 'password464',
      ip: '192.168.1.125',
      status: 'suspended',
      createdAt: '2024-01-07',
      lastActivity: '2024-01-17',
      notes: 'Vi phạm quảng cáo',
      activities: [
        { date: '2024-01-17', content: 'Quảng cáo sai sự thật', note: 'Tạm khóa' }
      ]
    },
    {
      id: 27,
      type: 'tiktok',
      storeName: 'TikTok Store 9',
      email: 'store9@tiktok.com',
      password: 'password797',
      ip: '192.168.1.126',
      status: 'pending',
      createdAt: '2024-01-14',
      lastActivity: '2024-01-20',
      notes: 'Chờ duyệt nội dung',
      activities: [
        { date: '2024-01-20', content: 'Gửi video duyệt', note: 'Chờ admin xem xét' }
      ]
    },
    {
      id: 28,
      type: 'temu',
      storeName: 'Temu Store 10',
      email: 'store10@temu.com',
      password: 'password132',
      ip: '192.168.1.127',
      status: 'active',
      createdAt: '2024-01-03',
      lastActivity: '2024-01-22',
      notes: 'Store thể thao',
      activities: [
        { date: '2024-01-22', content: 'Sự kiện thể thao', note: 'Tăng doanh thu 50%' }
      ]
    },
    {
      id: 29,
      type: 'gmc',
      storeName: 'GMC Store 10',
      email: 'store10@gmc.com',
      password: 'password465',
      ip: '192.168.1.128',
      status: 'active',
      createdAt: '2024-01-09',
      lastActivity: '2024-01-21',
      notes: 'Store sách',
      activities: [
        { date: '2024-01-21', content: 'Sách bestseller', note: 'Bán chạy nhất tháng' }
      ]
    },
    {
      id: 30,
      type: 'tiktok',
      storeName: 'TikTok Store 10',
      email: 'store10@tiktok.com',
      password: 'password798',
      ip: '192.168.1.129',
      status: 'suspended',
      createdAt: '2024-01-01',
      lastActivity: '2024-01-16',
      notes: 'Nội dung nhạy cảm',
      activities: [
        { date: '2024-01-16', content: 'Báo cáo nội dung', note: 'Vi phạm tiêu chuẩn' }
      ]
    }
  ];

  const calculateStats = (type = 'total') => {
    let filteredData = resources;
    if (type !== 'total') {
      filteredData = resources.filter(resource => resource.type === type);
    }
    
    const total = filteredData.length;
    const active = filteredData.filter(r => r.status === 'active').length;
    const suspended = filteredData.filter(r => r.status === 'suspended').length;
    const pending = filteredData.filter(r => r.status === 'pending').length;
    const activeRate = total > 0 ? ((active / total) * 100).toFixed(1) : 0;
    
    return { total, active, suspended, pending, activeRate };
  };

  const getResourceTypeInfo = (type) => {
    switch (type) {
      case 'temu': return { name: 'Temu', color: 'bg-blue-500', icon: '🛍️' };
      case 'gmc': return { name: 'GMC', color: 'bg-green-500', icon: '🛒' };
      case 'tiktok': return { name: 'TikTok', color: 'bg-pink-500', icon: '📱' };
      default: return { name: 'Total', color: 'bg-purple-500', icon: '📊' };
    }
  };

  const getStatusInfo = (status) => {
    switch (status) {
      case 'active':
        return { label: 'Hoạt động', color: 'bg-green-100 text-green-800', icon: CheckCircle };
      case 'suspended':
        return { label: 'Tạm ngưng', color: 'bg-red-100 text-red-800', icon: XCircle };
      case 'pending':
        return { label: 'Chờ duyệt', color: 'bg-yellow-100 text-yellow-800', icon: Clock };
      default:
        return { label: 'Không xác định', color: 'bg-gray-100 text-gray-800', icon: Clock };
    }
  };

  // Chart data
  const getChartData = () => {
    const filteredResources = resources;
    
    if (!filteredResources || filteredResources.length === 0) {
      return {
        labels: ['Không có dữ liệu'],
        datasets: [
          {
            label: 'Số lượng tài nguyên',
            data: [0],
            borderColor: '#10B981',
            backgroundColor: 'rgba(16, 185, 129, 0.1)',
            fill: true,
            tension: 0.4,
            pointBackgroundColor: '#10B981',
            pointBorderColor: '#fff',
            pointBorderWidth: 2,
            pointRadius: 6,
            pointHoverRadius: 8,
            yAxisID: 'y'
          },
          {
            label: 'Hoạt động tài nguyên',
            data: [0],
            borderColor: '#3B82F6',
            backgroundColor: 'rgba(59, 130, 246, 0.1)',
            fill: false,
            tension: 0.4,
            pointBackgroundColor: '#3B82F6',
            pointBorderColor: '#fff',
            pointBorderWidth: 2,
            pointRadius: 4,
            pointHoverRadius: 6,
            yAxisID: 'y1'
          }
        ]
      };
    }

    // 7 ngày gần đây
    const dayNames = ['Chủ nhật', 'Thứ 2', 'Thứ 3', 'Thứ 4', 'Thứ 5', 'Thứ 6', 'Thứ 7'];
    const labels = dayNames;
    
    const days = {};
    for (let i = 0; i < 7; i++) {
      days[i] = { resources: 0, activities: 0 };
    }
    
    // Lọc theo selectedResourceType
    let filteredData = filteredResources;
    if (selectedResourceType !== 'total') {
      filteredData = filteredResources.filter(resource => resource.type === selectedResourceType);
    } else {
      // Total = tổng của Temu + GMC + TikTok
      filteredData = filteredResources.filter(resource => 
        resource.type === 'temu' || resource.type === 'gmc' || resource.type === 'tiktok'
      );
    }
    
    filteredData.forEach(resource => {
      const date = new Date(resource.createdAt);
      const dayOfWeek = date.getDay();
      days[dayOfWeek].resources += 1;
      
      // Hoạt động dựa trên lastActivity
      if (resource.lastActivity) {
        const activityDate = new Date(resource.lastActivity);
        const activityDay = activityDate.getDay();
        days[activityDay].activities += 1;
      }
    });
    
    const resourceData = Object.values(days).map(d => d.resources);
    const activityData = Object.values(days).map(d => d.activities);
    
    // Tính toán dữ liệu cho từng loại
    const temuData = [];
    const gmcData = [];
    const tiktokData = [];
    
    for (let i = 0; i < 7; i++) {
      const temuCount = filteredResources.filter(resource => {
        const date = new Date(resource.createdAt);
        return resource.type === 'temu' && date.getDay() === i;
      }).length;
      
      const gmcCount = filteredResources.filter(resource => {
        const date = new Date(resource.createdAt);
        return resource.type === 'gmc' && date.getDay() === i;
      }).length;
      
      const tiktokCount = filteredResources.filter(resource => {
        const date = new Date(resource.createdAt);
        return resource.type === 'tiktok' && date.getDay() === i;
      }).length;
      
      temuData.push(temuCount);
      gmcData.push(gmcCount);
      tiktokData.push(tiktokCount);
    }
    
    if (selectedResourceType === 'total') {
      // Total = 3 đường riêng biệt
      return {
        labels: labels,
        datasets: [
          {
            label: 'Temu',
            data: temuData,
            borderColor: '#FF6B6B',
            backgroundColor: 'rgba(255, 107, 107, 0.15)',
            fill: true,
            tension: 0.6,
            pointBackgroundColor: '#FF6B6B',
            pointBorderColor: '#fff',
            pointBorderWidth: 3,
            pointRadius: 6,
            pointHoverRadius: 10,
            borderWidth: 3,
            yAxisID: 'y'
          },
          {
            label: 'GMC',
            data: gmcData,
            borderColor: '#4ECDC4',
            backgroundColor: 'rgba(78, 205, 196, 0.15)',
            fill: true,
            tension: 0.6,
            pointBackgroundColor: '#4ECDC4',
            pointBorderColor: '#fff',
            pointBorderWidth: 3,
            pointRadius: 6,
            pointHoverRadius: 10,
            borderWidth: 3,
            yAxisID: 'y'
          },
          {
            label: 'TikTok',
            data: tiktokData,
            borderColor: '#45B7D1',
            backgroundColor: 'rgba(69, 183, 209, 0.15)',
            fill: true,
            tension: 0.6,
            pointBackgroundColor: '#45B7D1',
            pointBorderColor: '#fff',
            pointBorderWidth: 3,
            pointRadius: 6,
            pointHoverRadius: 10,
            borderWidth: 3,
            yAxisID: 'y'
          }
        ]
      };
    } else {
      // Từng loại riêng = 1 đường
      let data, color, label;
             if (selectedResourceType === 'temu') {
         data = temuData;
         color = '#FF6B6B';
         label = 'Temu';
       } else if (selectedResourceType === 'gmc') {
         data = gmcData;
         color = '#4ECDC4';
         label = 'GMC';
       } else if (selectedResourceType === 'tiktok') {
         data = tiktokData;
         color = '#45B7D1';
         label = 'TikTok';
       }
      
      return {
        labels: labels,
        datasets: [
          {
            label: label,
            data: data,
            borderColor: color,
            backgroundColor: color.replace(')', ', 0.1)').replace('#', 'rgba('),
            fill: true,
            tension: 0.4,
            pointBackgroundColor: color,
            pointBorderColor: '#fff',
            pointBorderWidth: 2,
            pointRadius: 6,
            pointHoverRadius: 8,
            yAxisID: 'y'
          }
        ]
      };
    }
  };

  // Load data
  const loadResources = async () => {
    try {
      setLoading(true);
      setError(null);
      
      const response = await resourceApi.getResources(token);
      
      if (response.success && response.data) {
        setResources(response.data);
        setFilteredResources(response.data);
      } else {
        // Fallback to mock data if API fails
        setResources(mockResources);
        setFilteredResources(mockResources);
      }
    } catch (error) {
      console.error('❌ [ERROR] Error loading resources:', error);
      setError(`Lỗi khi tải dữ liệu: ${error.message}`);
      // Fallback to mock data
      setResources(mockResources);
      setFilteredResources(mockResources);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (token) {
      loadResources();
    }
  }, [token]);

  useEffect(() => {
    let filtered = resources;
    
    if (selectedResourceType !== 'total') {
      filtered = filtered.filter(resource => resource.type === selectedResourceType);
    }
    
    if (searchTerm) {
      filtered = filtered.filter(resource => 
        resource.storeName.toLowerCase().includes(searchTerm.toLowerCase()) ||
        resource.email.toLowerCase().includes(searchTerm.toLowerCase())
      );
    }
    
    if (statusFilter !== 'all') {
      filtered = filtered.filter(resource => resource.status === statusFilter);
    }
    
    setFilteredResources(filtered);
    setCurrentPage(1);
  }, [resources, selectedResourceType, searchTerm, statusFilter]);

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredResources.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(filteredResources.length / itemsPerPage);

  const handleAddResource = () => {
    setNewResource({
      type: 'temu',
      storeName: '',
      email: '',
      password: '',
      ip: '',
      status: 'active'
    });
    setShowAddModal(true);
  };

  const handleSubmitAdd = async (e) => {
    e.preventDefault();
    try {
      const response = await resourceApi.createResource(token, newResource);
      
      if (response.success) {
        // Reload data
        await loadResources();
        setShowAddModal(false);
        toast.success('Thêm tài nguyên thành công!');
      } else {
        toast.error('Lỗi khi thêm tài nguyên');
      }
    } catch (error) {
      console.error('❌ [ERROR] Error adding resource:', error);
      toast.error('Lỗi khi thêm tài nguyên');
    }
  };

  const handleViewDetails = (resource) => {
    setSelectedResource(resource);
    setShowDetailModal(true);
  };

  const handleDeleteResource = async (resourceId) => {
    if (window.confirm('Bạn có chắc chắn muốn xóa tài nguyên này?')) {
      try {
        const response = await resourceApi.deleteResource(token, resourceId);
        
        if (response.success) {
          // Reload data
          await loadResources();
          toast.success('Xóa tài nguyên thành công!');
        } else {
          toast.error('Lỗi khi xóa tài nguyên');
        }
      } catch (error) {
        console.error('❌ [ERROR] Error deleting resource:', error);
        toast.error('Lỗi khi xóa tài nguyên');
      }
    }
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  return (
    <div className="p-6 space-y-6">
      {/* Header */}
      <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between space-y-4 lg:space-y-0">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">Quản lý Tài nguyên</h1>
          <p className="text-gray-600 mt-1">Quản lý tất cả tài nguyên của bạn</p>
        </div>
        <button
          onClick={handleAddResource}
          className="flex items-center px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
        >
          <Plus className="w-4 h-4 mr-2" />
          Thêm Tài nguyên
        </button>
      </div>

      {/* Statistics Cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        {['total', 'temu', 'gmc', 'tiktok'].map((type) => {
          const stats = calculateStats(type);
          const typeInfo = getResourceTypeInfo(type);
          
          return (
            <div
              key={type}
              className={`p-6 rounded-xl shadow-lg cursor-pointer transition-all duration-200 hover:scale-105 ${
                selectedResourceType === type ? 'ring-2 ring-blue-500' : ''
              }`}
              onClick={() => setSelectedResourceType(type)}
            >
              <div className="flex items-center justify-between mb-4">
                <div className={`p-3 rounded-lg ${typeInfo.color} text-white`}>
                  <span className="text-2xl">{typeInfo.icon}</span>
                </div>
                <div className="text-right">
                  <p className="text-sm text-gray-600">{typeInfo.name}</p>
                  <p className="text-2xl font-bold text-gray-900">{stats.total}</p>
                </div>
              </div>
              
              <div className="space-y-2">
                <div className="flex justify-between text-sm">
                  <span className="text-green-600">Hoạt động: {stats.active}</span>
                  <span className="text-red-600">Tạm ngưng: {stats.suspended}</span>
                </div>
                <div className="flex justify-between text-sm">
                  <span className="text-yellow-600">Chờ duyệt: {stats.pending}</span>
                  <span className="text-blue-600">Tỷ lệ: {stats.activeRate}%</span>
                </div>
              </div>
            </div>
          );
        })}
      </div>

      {/* Chart */}
      <div className="bg-white p-6 rounded-xl shadow-lg">
                 <div className="flex items-center justify-between mb-4">
           <h3 className="text-lg font-semibold text-gray-900">Biểu đồ Doanh thu & Đơn hàng</h3>
           <div className="flex items-center space-x-2">
             <span className="text-sm text-gray-600">
               {getResourceTypeInfo(selectedResourceType).name} - 7 ngày gần đây
             </span>
           </div>
         </div>
                 <div className="h-64">
           <Line 
             data={getChartData()} 
             options={{
               responsive: true,
               maintainAspectRatio: false,
               plugins: {
                 legend: {
                   display: true,
                   position: 'top',
                   labels: {
                     usePointStyle: true,
                     padding: 20
                   }
                 }
               },
               scales: {
                 x: {
                   display: true,
                   title: {
                     display: true,
                     text: 'Ngày'
                   }
                 },
                 y: {
                   type: 'linear',
                   display: true,
                   position: 'left',
                   title: {
                     display: true,
                     text: 'Số lượng tài nguyên'
                   },
                   beginAtZero: true,
                   ticks: {
                     stepSize: 1,
                     callback: function(value, index, values) {
                       return value;
                     }
                   }
                 },
                 y1: {
                   type: 'linear',
                   display: true,
                   position: 'right',
                   title: {
                     display: true,
                     text: 'Đơn hàng mới'
                   },
                   beginAtZero: true,
                   grid: {
                     drawOnChartArea: false,
                   },
                   ticks: {
                     stepSize: 5
                   }
                 }
               }
             }}
           />
         </div>
      </div>

      {/* Filters */}
      <div className="bg-white p-6 rounded-xl shadow-lg">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <div className="relative">
            <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-gray-400" />
            <input
              type="text"
              placeholder="Tìm kiếm theo tên store, email..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
            />
          </div>

          <select
            value={statusFilter}
            onChange={(e) => setStatusFilter(e.target.value)}
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
          >
            <option value="all">Tất cả trạng thái</option>
            <option value="active">Hoạt động</option>
            <option value="suspended">Tạm ngưng</option>
            <option value="pending">Chờ duyệt</option>
          </select>

          <select
            value={itemsPerPage}
            onChange={(e) => setItemsPerPage(Number(e.target.value))}
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
          >
            <option value={5}>5 dòng/trang</option>
            <option value={10}>10 dòng/trang</option>
            <option value={20}>20 dòng/trang</option>
            <option value={50}>50 dòng/trang</option>
          </select>
        </div>
      </div>

      {/* Resources Table */}
      <div className="bg-white rounded-xl shadow-lg overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Tài nguyên
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Store
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Email
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  IP
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Trạng thái
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Ngày tạo
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Thao tác
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {currentItems.map((resource) => {
                const typeInfo = getResourceTypeInfo(resource.type);
                const statusInfo = getStatusInfo(resource.status);
                const StatusIcon = statusInfo.icon;
                
                return (
                  <tr key={resource.id} className="hover:bg-gray-50">
                    <td className="px-6 py-4 whitespace-nowrap">
                      <div className="flex items-center">
                        <span className="text-2xl mr-3">{typeInfo.icon}</span>
                        <div>
                          <div className="text-sm font-medium text-gray-900">
                            {typeInfo.name}
                          </div>
                        </div>
                      </div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <div className="text-sm text-gray-900">{resource.storeName}</div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <div className="text-sm text-gray-900">{resource.email}</div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <div className="text-sm text-gray-900">{resource.ip}</div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${statusInfo.color}`}>
                        <StatusIcon className="w-3 h-3 mr-1" />
                        {statusInfo.label}
                      </span>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                      {resource.createdAt}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
                      <div className="flex items-center space-x-2">
                        <button
                          onClick={() => handleViewDetails(resource)}
                          className="text-blue-600 hover:text-blue-900"
                          title="Xem chi tiết"
                        >
                          <Eye className="w-4 h-4" />
                        </button>
                        <button
                          onClick={() => handleDeleteResource(resource.id)}
                          className="text-red-600 hover:text-red-900"
                          title="Xóa"
                        >
                          <Trash2 className="w-4 h-4" />
                        </button>
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        <div className="bg-white px-4 py-3 flex items-center justify-between border-t border-gray-200 sm:px-6">
          <div className="flex-1 flex justify-between sm:hidden">
            <button
              onClick={() => setCurrentPage(currentPage - 1)}
              disabled={currentPage === 1}
              className="relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              Trước
            </button>
            <button
              onClick={() => setCurrentPage(currentPage + 1)}
              disabled={currentPage === totalPages}
              className="ml-3 relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              Sau
            </button>
          </div>
          <div className="hidden sm:flex-1 sm:flex sm:items-center sm:justify-between">
            <div>
              <p className="text-sm text-gray-700">
                Hiển thị <span className="font-medium">{indexOfFirstItem + 1}</span> đến{' '}
                <span className="font-medium">
                  {Math.min(indexOfLastItem, filteredResources.length)}
                </span>{' '}
                trong tổng số <span className="font-medium">{filteredResources.length}</span> kết quả
              </p>
            </div>
            <div>
              <nav className="relative z-0 inline-flex rounded-md shadow-sm -space-x-px">
                <button
                  onClick={() => setCurrentPage(currentPage - 1)}
                  disabled={currentPage === 1}
                  className="relative inline-flex items-center px-2 py-2 rounded-l-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  Trước
                </button>
                {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
                  <button
                    key={page}
                    onClick={() => setCurrentPage(page)}
                    className={`relative inline-flex items-center px-4 py-2 border text-sm font-medium ${
                      currentPage === page
                        ? 'z-10 bg-blue-50 border-blue-500 text-blue-600'
                        : 'bg-white border-gray-300 text-gray-500 hover:bg-gray-50'
                    }`}
                  >
                    {page}
                  </button>
                ))}
                <button
                  onClick={() => setCurrentPage(currentPage + 1)}
                  disabled={currentPage === totalPages}
                  className="relative inline-flex items-center px-2 py-2 rounded-r-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  Sau
                </button>
              </nav>
            </div>
          </div>
        </div>
      </div>

      {/* Add Resource Modal */}
      {showAddModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 backdrop-blur-sm overflow-y-auto h-full w-full z-50">
          <div className="relative top-20 mx-auto p-8 border-0 w-full max-w-md shadow-2xl rounded-2xl bg-white">
            <div className="flex items-center justify-between mb-6">
              <h3 className="text-2xl font-bold text-gray-900">Thêm Tài nguyên</h3>
              <button
                onClick={() => setShowAddModal(false)}
                className="p-2 text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-lg transition-all duration-200"
              >
                <X className="w-6 h-6" />
              </button>
            </div>
            
            <form onSubmit={handleSubmitAdd} className="space-y-6">
              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-2">Loại tài nguyên</label>
                <select
                  value={newResource.type}
                  onChange={(e) => setNewResource({...newResource, type: e.target.value})}
                  className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200"
                  required
                >
                  <option value="temu">Temu</option>
                  <option value="gmc">GMC</option>
                  <option value="tiktok">TikTok</option>
                </select>
              </div>
              
              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-2">Tên Store</label>
                <input
                  type="text"
                  value={newResource.storeName}
                  onChange={(e) => setNewResource({...newResource, storeName: e.target.value})}
                  className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200"
                  placeholder="Nhập tên store"
                  required
                />
              </div>
              
              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-2">Email</label>
                <input
                  type="email"
                  value={newResource.email}
                  onChange={(e) => setNewResource({...newResource, email: e.target.value})}
                  className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200"
                  placeholder="Nhập email"
                  required
                />
              </div>
              
              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-2">Mật khẩu</label>
                <input
                  type="password"
                  value={newResource.password}
                  onChange={(e) => setNewResource({...newResource, password: e.target.value})}
                  className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200"
                  placeholder="Nhập mật khẩu"
                  required
                />
              </div>
              
              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-2">IP</label>
                <input
                  type="text"
                  value={newResource.ip}
                  onChange={(e) => setNewResource({...newResource, ip: e.target.value})}
                  className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200"
                  placeholder="Nhập IP"
                  required
                />
              </div>
              
              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-2">Trạng thái</label>
                <select
                  value={newResource.status}
                  onChange={(e) => setNewResource({...newResource, status: e.target.value})}
                  className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200"
                  required
                >
                  <option value="active">Hoạt động</option>
                  <option value="suspended">Tạm ngưng</option>
                  <option value="pending">Chờ duyệt</option>
                </select>
              </div>
              
              <div className="flex space-x-4">
                <button
                  type="button"
                  onClick={() => setShowAddModal(false)}
                  className="flex-1 px-4 py-3 text-sm font-medium text-gray-700 bg-gray-100 rounded-xl hover:bg-gray-200 transition-all duration-200"
                >
                  Hủy
                </button>
                <button
                  type="submit"
                  className="flex-1 px-4 py-3 text-sm font-medium text-white bg-blue-600 rounded-xl hover:bg-blue-700 transition-all duration-200"
                >
                  Thêm
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Detail Modal */}
      {showDetailModal && selectedResource && (
        <div className="fixed inset-0 bg-black bg-opacity-50 backdrop-blur-sm overflow-y-auto h-full w-full z-50">
          <div className="relative top-10 mx-auto p-8 border-0 w-full max-w-4xl shadow-2xl rounded-2xl bg-white">
            <div className="flex items-center justify-between mb-6">
              <h3 className="text-2xl font-bold text-gray-900">Chi tiết Tài nguyên</h3>
              <button
                onClick={() => setShowDetailModal(false)}
                className="p-2 text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-lg transition-all duration-200"
              >
                <X className="w-6 h-6" />
              </button>
            </div>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
              <div className="space-y-4">
                <div className="bg-gray-50 p-4 rounded-lg">
                  <h4 className="font-semibold text-gray-900 mb-2">Thông tin cơ bản</h4>
                  <div className="space-y-2">
                    <div className="flex justify-between">
                      <span className="text-gray-600">Loại:</span>
                      <span className="font-medium">{getResourceTypeInfo(selectedResource.type).name}</span>
                    </div>
                    <div className="flex justify-between">
                      <span className="text-gray-600">Store:</span>
                      <span className="font-medium">{selectedResource.storeName}</span>
                    </div>
                    <div className="flex justify-between">
                      <span className="text-gray-600">Email:</span>
                      <span className="font-medium">{selectedResource.email}</span>
                    </div>
                    <div className="flex justify-between">
                      <span className="text-gray-600">IP:</span>
                      <span className="font-medium">{selectedResource.ip}</span>
                    </div>
                  </div>
                </div>
                
                <div className="bg-gray-50 p-4 rounded-lg">
                  <h4 className="font-semibold text-gray-900 mb-2">Trạng thái</h4>
                  <div className="space-y-2">
                    <div className="flex justify-between">
                      <span className="text-gray-600">Trạng thái:</span>
                      <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${getStatusInfo(selectedResource.status).color}`}>
                        {getStatusInfo(selectedResource.status).label}
                      </span>
                    </div>
                    <div className="flex justify-between">
                      <span className="text-gray-600">Ngày tạo:</span>
                      <span className="font-medium">{selectedResource.createdAt}</span>
                    </div>
                    <div className="flex justify-between">
                      <span className="text-gray-600">Hoạt động cuối:</span>
                      <span className="font-medium">{selectedResource.lastActivity}</span>
                    </div>
                  </div>
                </div>
              </div>
              
              <div className="space-y-4">
                <div className="bg-gray-50 p-4 rounded-lg">
                  <h4 className="font-semibold text-gray-900 mb-2">Ghi chú</h4>
                  <p className="text-gray-700">{selectedResource.notes || 'Không có ghi chú'}</p>
                </div>
                
                <div className="bg-gray-50 p-4 rounded-lg">
                  <h4 className="font-semibold text-gray-900 mb-2">Hoạt động gần đây</h4>
                  <div className="space-y-2">
                    {selectedResource.activities && selectedResource.activities.length > 0 ? (
                      selectedResource.activities.map((activity, index) => (
                        <div key={index} className="border-l-2 border-blue-500 pl-3">
                          <div className="flex justify-between items-start">
                            <span className="text-sm font-medium text-gray-900">{activity.content}</span>
                            <span className="text-xs text-gray-500">{activity.date}</span>
                          </div>
                          {activity.note && (
                            <p className="text-xs text-gray-600 mt-1">{activity.note}</p>
                          )}
                        </div>
                      ))
                    ) : (
                      <p className="text-gray-500 text-sm">Không có hoạt động nào</p>
                    )}
                  </div>
                </div>
              </div>
            </div>
            
            <div className="flex justify-end">
              <button
                onClick={() => setShowDetailModal(false)}
                className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200 transition-all duration-200"
              >
                Đóng
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SellerResources;
